import React from 'react';
import { ValidationIcon } from '../../../icons';

interface FullNameFieldProps {
  value: string;
  error?: string;
  isValid: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FullNameField: React.FC<FullNameFieldProps> = ({
  value,
  error,
  isValid,
  onChange,
}) => {
  const inputBaseClass = 'w-full p-3 border rounded-md shadow-sm text-sm focus:ring-primary focus:border-primary bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500';
  const errorBorderClass = 'border-red-500';
  const normalBorderClass = 'border-medium-gray dark:border-gray-600';

  return (
    <div className="relative">
      <label htmlFor="fullName" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
        Nome Completo *
      </label>
      <div className="relative">
      <input
        type="text"
        name="fullName"
        id="fullName"
        value={value}
        onChange={onChange}
        minLength={5}
        maxLength={100}
        autoComplete="name"
        className={`${inputBaseClass} ${error ? errorBorderClass : normalBorderClass}`}
        aria-describedby={error ? 'fullName-error' : undefined}
      />
      <ValidationIcon isValid={isValid} />
      {error && (
        <p id="fullName-error" className="text-xs text-red-500 mt-1">
          {error}
        </p>
      )}
      </div>
    </div>
  );
};

export default FullNameField; 